export default __webpack_public_path__ + "static/media/material-scissor.3b1a5d7e.svg";